import { useAuth } from "./contexts/AuthContext";
import { useKpi } from "./lib/useKpi";
import { Header } from "./components/Header";
import { ManagerSelector } from "./components/ManagerSelector";
import { PeriodSelector } from "./components/PeriodSelector";
import { BottomNav } from "./components/BottomNav";
import { NoDataOverlay } from "./components/NoDataOverlay";
import { StatsScreen } from "./screens/StatsScreen";
import { RatingScreen } from "./screens/RatingScreen";
import { ProgressScreen } from "./screens/ProgressScreen";
import { BonusScreen } from "./screens/BonusScreen";
import { AdminScreen } from "./screens/AdminScreen";
import { getTg } from "./lib/tg";

const BOT_LINK = "https://t.me/BRZCRMKPI_bot";

export default function App() {
  const { me, error, maintenanceMsg, managerId, period, periodId, screen, t, lang, showAdmin, availableMonths } = useAuth();
  const { kpi, loading, error: kpiError } = useKpi(managerId, period, periodId);

  const tg = getTg();
  const isInTelegram = !!tg && !!tg.initData;

  if (!isInTelegram) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-slate-100">
        <div className="bg-white rounded-2xl p-6 text-center border border-slate-200 shadow max-w-sm w-full">
          <div className="text-5xl mb-3">📱</div>
          <div className="text-base font-semibold text-slate-900">Откройте в Telegram</div>
          <div className="text-sm text-slate-600 mt-2 leading-relaxed">KPI-кабинет работает только внутри Telegram-приложения.</div>
          <a href={BOT_LINK} className="mt-4 inline-block bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-xl px-5 py-2.5 transition">Перейти к боту</a>
        </div>
      </div>
    );
  }

  if (error === "MAINTENANCE") {
    const msg = lang === "uk" ? maintenanceMsg.uk : maintenanceMsg.ru;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-slate-100">
        <div className="bg-white rounded-2xl p-6 text-center border border-slate-200 shadow max-w-sm w-full">
          <div className="text-5xl mb-3">🔧</div>
          <div className="text-base font-semibold text-slate-900">{t("maintenance_title")}</div>
          <div className="text-sm text-slate-600 mt-2 leading-relaxed whitespace-pre-line">{msg || t("maintenance_fallback")}</div>
        </div>
      </div>
    );
  }

  if (error === "ACCESS_REVOKED" || error === "USER_NOT_REGISTERED") {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-slate-100">
        <div className="bg-white rounded-2xl p-6 text-center border border-slate-200 shadow">
          <div className="text-4xl mb-2">🔒</div>
          <div className="text-base font-semibold text-slate-900">{t("err_access_denied")}</div>
          <div className="text-sm text-slate-600 mt-1">{t("err_access_admin_note")}</div>
        </div>
      </div>
    );
  }
  if (error) return <div className="p-6 text-rose-600">Ошибка: {error}</div>;
  if (!me) return <div className="p-6 text-slate-500">{t("err_loading")}</div>;

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      <Header />
      <ManagerSelector />
      <PeriodSelector availableMonths={availableMonths} />
      <main className="flex-1 overflow-y-auto pb-20">
        {kpiError && <div className="p-6 text-rose-600">Ошибка KPI: {kpiError}</div>}
        {loading && !kpi && <div className="p-6 text-slate-500">{t("err_loading")}</div>}
        {kpi && !kpi.hasData && <NoDataOverlay />}
        {kpi && kpi.hasData && (
          <>
            {screen === "stats" && <StatsScreen kpi={kpi} />}
            {screen === "rating" && <RatingScreen />}
            {screen === "progress" && <ProgressScreen />}
            {screen === "bonus" && <BonusScreen kpi={kpi} />}
          </>
        )}
      </main>
      <BottomNav />
      {showAdmin && <AdminScreen />}
    </div>
  );
}
